import './styles/metadata-filter.scss'

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Form, Button, Icon, Message } from 'semantic-ui-react'

import api from '../redux/api'
import AsyncFilterDropdown from '../components/AsyncFilterDropdown'

const initialState = {
  key: '',
  value: '',
}

export default class MetadataFilter extends React.Component {
  static propTypes = {
    itemIndex: PropTypes.number.isRequired,
    defaultFilterConfig: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
      error: PropTypes.string,
    }),
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
  }

  state = {
    key: (this.props.defaultFilterConfig && this.props.defaultFilterConfig.key) || initialState.key,
    value: (this.props.defaultFilterConfig && this.props.defaultFilterConfig.value) || initialState.value,
    error: (this.props.defaultFilterConfig && this.props.defaultFilterConfig.error),
    valueActive: false,
  }

  handleKeyChange = (data) => {
    this.setState({ key: data && data.value }, () => {
      this.handleBlur()
    })
  }

  handleValueChange = (event) => {
    this.setState({ value: event.currentTarget.value })
  }

  handleBlur = () => {
    const { key, value } = this.state
    const { itemIndex } = this.props

    this.setState({ valueActive: false }, () => {
      this.props.onChange(itemIndex, { key, value })
    })
  }

  handleFocus = () => {
    this.setState({ valueActive: true })
  }

  handleRemove = (evt) => {
    evt.preventDefault()
    const { itemIndex } = this.props
    this.props.onRemove(itemIndex)
  }

  render() {
    const { key, value, error, valueActive } = this.state

    const metadataValueClass = classnames('metadata-value', { active: valueActive })

    return (
      <div className="metadata-filter">
        <Form error={error && true}>
          <Form.Group widths="equal">
            <div className="metadata-key">
              <AsyncFilterDropdown
                getOptionsByFilter={api.loadMetadataKeys}
                count={50}
                placeholder="Key"
                value={key}
                error={error && true}
                onChange={this.handleKeyChange}
              />
            </div>

            <div className={metadataValueClass}>
              <div className="value-tooltip">
                <span>You can use wildcard expressions to specify metadata values.</span>
                <span>For example:</span><b>*.txt</b> or <b>some*value*ext</b>
              </div>

              <Form.Input
                fluid
                placeholder="Value"
                value={value}
                error={error && true}
                onChange={this.handleValueChange}
                onBlur={this.handleBlur}
                onFocus={this.handleFocus}
              />
            </div>

            <div>
              <Button icon onClick={this.handleRemove}>
                <Icon name="delete" />
              </Button>
            </div>
          </Form.Group>
          {error && <Message error content={error} />}
        </Form>
      </div>
    )
  }
}
